import { collection, limit, orderBy, query, type Query } from 'firebase/firestore';
import { db } from './firebase';
import { QB_EXPENSES_ACCOUNT_DISCOVERY_LIMIT } from './qbExpensesQueryBounds';

export {
  QB_EXPENSES_ACCOUNT_DISCOVERY_LIMIT,
  QB_EXPENSES_PL_LOOKBACK_MONTHS,
  QB_EXPENSES_PL_MAX_DOCS,
  qbExpensesProjectPLLookbackYmd,
} from './qbExpensesQueryBounds';

/** Latest synced expenses — enough to populate account/bank dropdowns. */
export function qbExpensesAccountDiscoveryQuery(): Query {
  return query(
    collection(db, 'qbExpenses'),
    orderBy('txnDate', 'desc'),
    limit(QB_EXPENSES_ACCOUNT_DISCOVERY_LIMIT),
  );
}

/** Full qbExpenses collection — Project P&L outstanding matches financeAgent. */
export function qbExpensesProjectPLQuery(): Query {
  return query(collection(db, 'qbExpenses'));
}
